import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { of, Observable } from 'rxjs';
import {
  catchError,
  map,
  switchMap,
  filter,
  withLatestFrom
} from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DealType } from '../../types/deal.types';
import {
  LoadBidsSuccess,
  LoadBidsFail,
  LoadBids,
  BidsActionTypes
} from './actions';
import { DealService } from '../../services/deal.service';
import { DealVersion } from '../../types/deal.types';
import { LoadSuccess, DealActionTypes } from '../deal/actions';
import { SharedState, getCurrentDealVersionDistinct } from '../reducer';
import { PermissionsFacade } from '../../facades/permissions.facade';

@Injectable()
export class BidsEffects {
  
  public loadBids$: Observable<LoadBids> = createEffect(() => this.actions$.pipe(
    ofType(DealActionTypes.LoadSuccess),
    withLatestFrom(this.store.pipe(getCurrentDealVersionDistinct)),
    filter(
      ([, deal]: [LoadSuccess, DealVersion]) =>
        deal && deal.dealType === DealType.competitive
    ),
    switchMap(([, deal]: [LoadSuccess, DealVersion]) =>
      this.permissionsFacade
        .withPermission('competitiveBids')
        .pipe(switchMap(() => of(new LoadBids(deal.id))))
    )
  ));

  
  public loadBidsData$: Observable<
    LoadBidsSuccess | LoadBidsFail
  > = createEffect(() => this.actions$.pipe(
    ofType(BidsActionTypes.LoadBids),
    switchMap((action: LoadBids) =>
      this.dealService.getBids(action.payload).pipe(
        map((deals: any) => new LoadBidsSuccess({ data: deals })),
        catchError((error) =>
          of(new LoadBidsFail(error && (error as Error).message))
        )
      )
    )
  ));

  constructor(
    public dealService: DealService,
    private actions$: Actions,
    private store: Store<SharedState>,
    private permissionsFacade: PermissionsFacade
  ) {}
}
